const userLists = {
  userLists: 'Lista de usuarios administradores',
  showing: 'Mostrado',
  userListsOf: 'usuarios',
  noUserListsFound: 'No se encontraron usuarios',
  actionsDropdown: {
    details: 'Detalles',
    deactivate: 'Desactivar',
    edit: 'Editar',
  },
  modal: {
    editUser: 'Editar usuario',
    name: 'Nombre',
    email: 'Correo electrónico',
    role: 'Rol',
    messengers: 'Enlaces',
    priceplan: 'Plan de precios',
    manager: 'Administrador',
    isAlive: 'Activo',
    emailVerified: 'Correo electrónico verificado',
    successUpdate: 'Los cambios en los datos del usuario se han aplicado correctamente',
  },
  tableDropdown: {
    quickActions: 'Menú de acciones rápidas',
    refresh: 'Actualizar',
    exportUserList: 'Exportar',
    exportUserListCurrent: 'Exportar actual',
  }
};

export default userLists;
